import React from "react";

const Column = React.forwardRef<HTMLDivElement, React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement> ,HTMLDivElement>>((props, ref) => {
  return <div
    ref={ref}
    {...props}
    className={"flex flex-column " + ( props?.className  || "")}
  />;
})

export default Column;
